import {AddIcon, ChevronRightIcon} from '@chakra-ui/icons';
import {Box, Stack, Text} from '@chakra-ui/react';
import React from 'react';
import {
  getWorldTypeAccentColor,
  hiddenScrollbarStyles,
} from './config';
import {getCoverContent} from './coverContent';
import OpenModalButton from './OpenModalButton';
import SpaceportWorldCard from './SpaceportWorldCard';


const PublicWorldsList = ({
  currentWorld,
  onNewWorldClick,
  onWorldClick,
  worldType,
  worlds,
}) => {
  const isCurrentWorldNotInList = currentWorld?.rules?.worldType === worldType;
  const content = getCoverContent(worldType);
  const accentColor = getWorldTypeAccentColor({
    rules: {
      worldType,
    },
  });

  return (
    <>
      <Box flex={1} minH={0} overflowY="auto" sx={hiddenScrollbarStyles}>
        <Stack gap={2}>
          {isCurrentWorldNotInList && (
            <SpaceportWorldCard
              accentColorOverride="#00FF00"
              bgOverride="#0B2E00"
              world={{
                ...currentWorld,
                name: currentWorld.name === 'SoloOffline' ? 'Solo Room' : currentWorld.name,
              }}
            />
          )}

          <Text
            color="white"
            fontSize="md"
            fontWeight="bold"
            lineHeight="1.2"
            marginTop={2}
            fontFamily="Saira Variable"
            w="full"
          >
            {content.publicListLabel}
          </Text>

          {worlds.map(world => (
            <SpaceportWorldCard
              key={world._id}
              onClick={onWorldClick}
              world={world}
            />
          ))}
        </Stack>
      </Box>

      <Box flexShrink={0}>
        <OpenModalButton
          bgColor={accentColor}
          color="black"
          label={content.createLabel}
          leftIcon={<AddIcon fontSize="20px"/>}
          onClick={onNewWorldClick}
          rightIcon={<ChevronRightIcon fontSize="30px"/>}
          worldType={worldType}
        />
      </Box>
    </>
  );
};

export default PublicWorldsList;
